var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(false)?_c('MemberCredential'):_c('MemberCredentialNew')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }